import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import { useUpdatePeriodicTasksMutation } from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { omit } from "lodash-es"
import React from "react"
import { ErrorToast, SuccessToast } from "utils/AppToaster"
import { useTaskSelector } from "./interfaces"
const ReTriggerDialog = () => {
  const [selectedTasks, reset] = useTaskSelector(store => [
    Object.keys(store.selected),
    store.reset,
  ])
  const [filter, setFilter] = useSearchFilter()
  const taskIds = filter.task ? [filter.task] : selectedTasks

  const [update, { loading }] = useUpdatePeriodicTasksMutation({
    onCompleted() {
      SuccessToast("Successfully triggered tasks")
      reset()
      handleClose()
    },
    onError() {
      return ErrorToast("Failed to re-trigger tasks")
    },
  })

  function handleClose() {
    setFilter(prev => omit(prev, ["task", "view", "name"]))
  }
  return (
    <CustomDialog
      light
      title="Trigger Tasks"
      isOpen={filter.view === "trigger"}
      onClose={handleClose}
      footerRightButton={
        <CustomButton
          onClick={() => {
            update({
              variables: {
                ids: taskIds,
                enabled: true,
              },
            })
          }}
          loading={loading}
          dark
          icon="endorsed"
          text={"Trigger"}
        />
      }
    >
      <h6 className="text-center">
        Are you sure you want to trigger{" "}
        <span className="font-600">
          {taskIds.length === 1 ? filter.name : taskIds.length}
        </span>{" "}
        selected {taskIds.length === 1 ? "task" : "tasks"}?
      </h6>
    </CustomDialog>
  )
}

export default ReTriggerDialog
